import { TypographyTextStyleTable } from '@af/design-system-docs-ui';
import clearHeadingsDo from "../../../../src/pages/foundations/typography/applying-typography/_assets/clear-headings-do.png";
import clearHeadingsDont from "../../../../src/pages/foundations/typography/applying-typography/_assets/clear-headings-dont.png";
import largeHeadingsDo from "../../../../src/pages/foundations/typography/applying-typography/_assets/large-headings-do.png";
import largeHeadingsDont from "../../../../src/pages/foundations/typography/applying-typography/_assets/large-headings-dont.png";
import differentiateHeadingsDo from "../../../../src/pages/foundations/typography/applying-typography/_assets/differentiate-headings-do.png";
import differentiateHeadingsDont from "../../../../src/pages/foundations/typography/applying-typography/_assets/differentiate-headings-dont.png";
import useBodyTextDo from "../../../../src/pages/foundations/typography/applying-typography/_assets/use-body-text-do.png";
import useBodyTextDont from "../../../../src/pages/foundations/typography/applying-typography/_assets/use-body-text-dont.png";
import componentsDo from "../../../../src/pages/foundations/typography/applying-typography/_assets/components-do.png";
import componentsDont from "../../../../src/pages/foundations/typography/applying-typography/_assets/components-dont.png";
import textStylesDo from "../../../../src/pages/foundations/typography/applying-typography/_assets/text-styles-do.png";
import emphasiseMetricDo from "../../../../src/pages/foundations/typography/applying-typography/_assets/emphasise-metric-do.png";
import emphasiseMetricDont from "../../../../src/pages/foundations/typography/applying-typography/_assets/emphasise-metric-dont.png";
import smallTextDo from "../../../../src/pages/foundations/typography/applying-typography/_assets/small-text-do.png";
import smallTextDont from "../../../../src/pages/foundations/typography/applying-typography/_assets/small-text-dont.png";
import shortStatementDo from "../../../../src/pages/foundations/typography/applying-typography/_assets/short-statement-do.png";
import shortStatementDont from "../../../../src/pages/foundations/typography/applying-typography/_assets/short-statement-dont.png";
import chartTitleDo from "../../../../src/pages/foundations/typography/applying-typography/_assets/chart-title-do.png";
import chartTitleDont from "../../../../src/pages/foundations/typography/applying-typography/_assets/chart-title-dont.png";
import totalDo from "../../../../src/pages/foundations/typography/applying-typography/_assets/total-do.png";
import totalDont from "../../../../src/pages/foundations/typography/applying-typography/_assets/total-dont.png";
import fontWeightDo from "../../../../src/pages/foundations/typography/applying-typography/_assets/font-weight-do.png";
import fontWeightDont from "../../../../src/pages/foundations/typography/applying-typography/_assets/font-weight-dont.png";
import linksDo from "../../../../src/pages/foundations/typography/applying-typography/_assets/links-do.png";
import linksDont from "../../../../src/pages/foundations/typography/applying-typography/_assets/links-dont.png";
import allCapsDo from "../../../../src/pages/foundations/typography/applying-typography/_assets/all-caps-do.png";
import allCapsDont from "../../../../src/pages/foundations/typography/applying-typography/_assets/all-caps-dont.png";
import truncationDo from "../../../../src/pages/foundations/typography/applying-typography/_assets/truncation-do.png";
import truncationDont from "../../../../src/pages/foundations/typography/applying-typography/_assets/truncation-dont.png";
import * as React from 'react';
export default {
  TypographyTextStyleTable,
  clearHeadingsDo,
  clearHeadingsDont,
  largeHeadingsDo,
  largeHeadingsDont,
  differentiateHeadingsDo,
  differentiateHeadingsDont,
  useBodyTextDo,
  useBodyTextDont,
  componentsDo,
  componentsDont,
  textStylesDo,
  emphasiseMetricDo,
  emphasiseMetricDont,
  smallTextDo,
  smallTextDont,
  shortStatementDo,
  shortStatementDont,
  chartTitleDo,
  chartTitleDont,
  totalDo,
  totalDont,
  fontWeightDo,
  fontWeightDont,
  linksDo,
  linksDont,
  allCapsDo,
  allCapsDont,
  truncationDo,
  truncationDont,
  React
};